module.exports = __webpack_public_path__ + "img/dropdown-button.88aeca76.svg";